import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/loader.svg'


_pushScopeId("data-v-28f50186")
const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { for: "new-email" }, "Email", -1)
const _hoisted_3 = ["value"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "new-password" }, "Password", -1)
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { style: {"padding-bottom":"1rem"} }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { id: "error-message" }
const _hoisted_10 = { id: "error-message" }
const _hoisted_11 = {
  key: 0,
  id: "error-message"
}
const _hoisted_12 = { id: "error-message" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 1,
  id: "loading-wrap"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("input", {
        type: "email",
        id: "new-email",
        class: "form-input",
        value: _ctx.email,
        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleChangeEmail && _ctx.handleChangeEmail(...args))),
        onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleChangeEmail && _ctx.handleChangeEmail(...args)))
      }, null, 40, _hoisted_3),
      _hoisted_4,
      _createElementVNode("input", {
        type: "password",
        id: "new-password",
        class: "form-input",
        value: _ctx.password,
        onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleChangePassword && _ctx.handleChangePassword(...args))),
        onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleChangePassword && _ctx.handleChangePassword(...args)))
      }, null, 40, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("span", {
          id: "forgot-password",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openForgotPass && _ctx.openForgotPass(...args)))
        }, "Forgot Password?")
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.emailError), 1),
      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.passwordError), 1),
      (_ctx.unregisteredError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, " This email is not registered. "))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.generalError), 1)
    ]),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          "aria-label": "Login",
          class: "modal-select-btn",
          id: "login",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args))),
          type: "submit",
          disabled: !_ctx.canLogin
        }, " Login ", 8, _hoisted_13))
      : (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
  ], 32))
}